module.exports = __webpack_public_path__ + "img/coin.47c58701.png";